export default "__VITE_ASSET__BGxI09GV__"